export default __webpack_public_path__ + "static/learn-more-classy-63cd7bb68c5a88fbc0f328282a981b36.jpeg";